import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const SearchWrapper = styled.div`
  ${tw`w-103px md:w-222px lg:w-417px hidden sm:flex justify-end`}
`;
